import '@/app/globals.css'
import { ROUTES } from '@/app/lib/constants'
import { CoursesPage } from '@/app/modules/course/pages'
import { ApiService } from '@/app/services/ApiService'
import { CourseService } from '@/app/services/courses'
import { UserService } from '@/app/services/user'
import '@/styles/course.css'
import '@/styles/styles.css'
import { isBoom } from '@hapi/boom'

const cookieName = process.env.NEXT_PUBLIC_AUTH_COOKIE_NAME

export async function getServerSideProps(context) {
  const { req, locale } = context

  try {
    ApiService.setAccessToken(req.cookies?.[cookieName] || '')
    ApiService.setHeader('accept-language', locale ?? 'en')

    const recommendationsPromise = UserService.getRecommendations()
    const initialCoursesPromise = CourseService.getCourses(
      {},
      { limit: 8 },
      { qualityScore: 'desc', random: 'asc' }
    )

    const [recommendations, initialCoursesResponse] = await Promise.all([
      recommendationsPromise,
      initialCoursesPromise,
    ])

    return {
      props: {
        recommendations,
        initialCoursesResponse: {
          pages: [initialCoursesResponse],
          pageParams: [1],
        },
        messages: {
          ...(await import(`@/locales/${context.locale}/strings.json`)).default,
          ...(await import(`@/locales/${context.locale}/navigation.json`))
            .default,
        },
      },
    }
  } catch (e) {
    console.error(e)
    if (isBoom(e, 401)) {
      return {
        redirect: {
          destination: ROUTES.logout,
          permanent: false,
          locale,
        },
      }
    } else if (isBoom(e, 403)) {
      return {
        redirect: {
          destination: `/${locale}${ROUTES.accessDenied}`,
          permanent: false,
          locale,
        },
      }
    }

    throw e
  }
}

export default CoursesPage
